import { useEffect, useState } from "react";
import { Check, Copy, Gift, Share2 } from "lucide-react";
import { api } from "@/lib/api";
import { inviteLink } from "@/lib/referral";

// Shown inside sale celebrations; hidden once a friend has joined.
export default function InviteNudge({ compact = false }) {
  const [code, setCode] = useState(null);
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    api.get("/referrals/me").then(({ data }) => { if (!data.joined) setCode(data.code); }).catch(() => {});
  }, []);
  if (!code) return null;
  const link = inviteLink(code);
  const text = "I use SnapList to draft my eBay listings from photos. Sign up with my link and we both get free time:";

  const share = async () => {
    try {
      if (navigator.share) return await navigator.share({ title: "SnapList", text, url: link });
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch { /* cancelled */ }
  };

  return (
    <div className={`rounded-xl border border-emerald-200 bg-emerald-50 text-left ${compact ? "p-2.5" : "p-3"}`} data-testid="invite-nudge">
      <p className="flex items-start gap-2 text-sm text-emerald-900">
        <Gift className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />
        <span>{compact ? <><b>Know another reseller?</b> You both get up to a free month.</> : <><b>Share SnapList</b> — when a friend subscribes, you both get a free month (2 weeks on Starter).</>}</span>
      </p>
      <button type="button" onClick={share} data-testid="invite-nudge-share"
        className="mt-2 flex h-9 w-full items-center justify-center gap-1.5 rounded-full bg-emerald-600 text-sm font-semibold text-white transition-colors hover:bg-emerald-700">
        {copied ? <><Check className="h-4 w-4" /> Link copied</> : navigator.share ? <><Share2 className="h-4 w-4" /> Invite a friend</> : <><Copy className="h-4 w-4" /> Copy invite link</>}
      </button>
    </div>
  );
}
